import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { THEME_COLORS } from "../../context/constants";

const useStyles = makeStyles((theme: Theme) => ({
  backgroundContainer: {
    position: "relative",
    overflow: "hidden",
  },
  lightningBg: {
    position: "absolute",
    opacity: 0.1,
    zIndex: -1,
    width: "100%",
    height: "100%",
    top: -70,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  pageContainer: {
    padding: theme.spacing(4),
    textAlign: "center",
    maxWidth: 1200,
    margin: "0 auto",
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  subtitle: {
    marginBottom: theme.spacing(4),
    marginLeft: "auto",
    marginRight: "auto",
  },
  plansContainer: {
    marginTop: theme.spacing(4),
    justifyContent: "center",
  },
  planCard: {
    maxWidth: 345,
    margin: theme.spacing(2),
    borderRadius: 12,
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "translateY(-5px)",
    },
  },
  planTitle: {
    fontWeight: 700,
    textTransform: "uppercase",
    color: theme.palette.text.primary,
  },
  planPrice: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    margin: theme.spacing(2, 0),
  },
  includesTitle: {
    fontWeight: 600,
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
  },
  featureList: {
    textAlign: "left",
    paddingLeft: theme.spacing(2),
  },
  featureItem: {
    padding: theme.spacing(0.5, 0),
  },
  customButton: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5),
    fontWeight: 600,
  },
  backButton: {
    marginTop: theme.spacing(4),
    padding: "12px",
    background: THEME_COLORS.yellow,
    color: "black",
    borderRadius: "8px",
    textTransform: "none",
    maxHeight: "50px",
  },
  buttonBox: {
    display: "flex",
    marginBottom: "32px",
  },
  divider: {
    margin: theme.spacing(3, 0),
    backgroundColor: theme.palette.divider,
  },
  alignedLeft: {
    flexWrap: "wrap",
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
    width: "100%",
  },
}));

export default useStyles;
